const CT_SHOW = 'CT_SHOW'
const CT_SHOW_REQUEST = 'CT_SHOW_REQUEST'

const CT_HIDE = 'CT_HIDE'
const CT_HIDE_REQUEST = 'CT_HIDE_REQUEST'

export {
  CT_HIDE,
  CT_HIDE_REQUEST,
  CT_SHOW,
  CT_SHOW_REQUEST
}



// WEBPACK FOOTER //
// ./src/const/countTimer.js